<script setup lang="ts">
import type Article from "~/types/Article";

const props = defineProps({
    article: {
        type: Object as PropType<Article>,
        required: false,
        default: null,
    },
});
</script>

<template>
    <div class="mx-auto mb-6 overflow-hidden rounded-xl border p-6 shadow-xl md:flex md:h-72">
        <div class="h-60 flex-none overflow-hidden text-center md:h-full md:w-2/5 md:pr-8">
            <NuxtLink :to="`/articles/${article?.slug}`">
                <img :src="article?.photo" alt="Article Image" class="w-full place-self-center object-cover" />
            </NuxtLink>
        </div>
        <div class="flex-1 pt-2 md:pt-0">
            <h3 class="mb-4 text-xl font-bold">
                {{ article.title }}
            </h3>

            <p class="overflow-hidden">{{ article.excerpt }}</p>

            <div class="pt-6 md:pt-4">
                <ButtonSecondary
                    type="link"
                    :href="`/articles/${article?.slug}`"
                    :py="'py-0.5'"
                    class="w-full flex-none md:w-auto"
                    >Read More
                </ButtonSecondary>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
